import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from 'react-router-dom';
import { useEffect, useState } from 'react'
import { Box } from '@mui/material';
import Navbar from './layout/Navbar';
import Footer from './layout/Footer';
import CustomDivider from './shared/utils/CustomDivider';
import ScrollToTop from './shared/utils/ScrollToTop';
import { AppRoutes, AuthRoutes } from './routes';
import { ToastContainer } from 'react-toastify';
import { ToasterProvider } from './shared/utils/ToasterProvider';
import ClearAllStoresOnNavigate from './shared/utils/ClearAllStoresOnNavigate';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import NotFoundPage from './pages/NotFoundPage';
import Loader from './shared/utils/Loader';
import useAuthStore from './shared/store/useAuthStore';
import { AuthProvider } from './shared/hook/AuthContext';



// ✅ Layout Wrapper
// const Layout = ({ children, hideLayout = false }) => {
//   const location = useLocation();
//   const isAuthPage = AuthRoutes
//     .some((route) =>
//       location?.pathname?.startsWith(route.path.split('/:')[0])
//     );
//   const isNotFoundPage = location.pathname === '/404';

//   // hide navbar & footer on auth + 404
//   const hideLayouts = isAuthPage || isNotFoundPage;

//   return (
//     <Box sx={{ minHeight: '100vh' }}>
//       {!hideLayouts && (
//         <>
//           {!hideLayout && <Navbar />}
//           {!hideLayout && <CustomDivider orientation="horizontal" size={20} />}
//           {!hideLayout && <ScrollToTop />}
//         </>
//       )}

//       {children}

//       {hideLayout && <Loader />}
//       {!hideLayouts && (
//         <>
//           {!hideLayout && <CustomDivider orientation="horizontal" />}
//           {!hideLayout && <Footer />}
//         </>
//       )}
//     </Box>
//   );
// };


const Layout = ({ children, hideLayout = false }) => {
  const location = useLocation();
  const isAuthPage = AuthRoutes
    .some((route) =>
      location?.pathname?.startsWith(route.path.split('/:')[0])
    );
  const isNotFoundPage = location.pathname === '/404';

  // hide navbar & footer on auth + 404
  const hideLayouts = isAuthPage || isNotFoundPage;

  return (
    <Box sx={{ minHeight: '100vh' }}>
      {!hideLayouts && (
        <>
          {!hideLayout && <Navbar />}
          {/* {!hideLayout && <CustomDivider orientation="horizontal" size={20} />} */}
          {!hideLayout && <ScrollToTop />}
        </>
      )}

      {children}

      {/* ✅ Show loader only for AppRoutes, not for AuthRoutes */}
      {!isAuthPage && hideLayout && <Loader />}

      {!hideLayouts && (
        <>
          {!hideLayout && <CustomDivider orientation="horizontal" size={"2rem"} />}
          {!hideLayout && <Footer />}
        </>
      )}
    </Box>
  );
};







// ✅ Protected Route (optional admin restriction)
const ProtectedRoute = ({ element }) => {

  const token = useAuthStore((state) => state.accessToken);
  return token ? element : <Navigate to="/StudentLogin" replace />;
};

// ✅ Main App
function App() {
  const token = useAuthStore((state) => state.accessToken);
  const isLoggedIn = !!token;
  const [hideLayout, setHideLayout] = useState(false);
  const storedPath = localStorage.getItem("lastVisitedPath") || "/"
  useEffect(() => {
    setTimeout(() => {
      localStorage.removeItem("lastVisitedPath");
    }, 500);
  }, [])




  return (
    <Router>
      <AuthProvider>
        <ToastContainer />
        <ClearAllStoresOnNavigate />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ToasterProvider>
            <Layout hideLayout={hideLayout}>
              <Routes>
                {/* Auth Routes */}
                {AuthRoutes.map(({ path, Component }) => (
                  <Route
                    key={path}
                    path={path}
                    element={
                      isLoggedIn ? (
                        <Navigate to={storedPath} replace state={{ from: "/StudentLogin" }} />
                      ) : (
                        <Component />
                      )
                    }
                  // element={<Component />}
                  />
                ))}

                {/* App Routes */}
                {AppRoutes.map(({ path, Component, isProtected }) => (
                  <Route
                    key={path}
                    path={path}
                    element={
                      isProtected ? (
                        <ProtectedRoute element={<Component onLoadingChange={setHideLayout} />} />
                      ) : (
                        <Component onLoadingChange={setHideLayout} />
                      )
                    }
                  />
                ))}
                {/* Not Found */}
                <Route path="/404" element={<NotFoundPage />} />
                <Route path="*" element={<Navigate to="/404" replace />} />
              </Routes>
            </Layout>
          </ToasterProvider>
        </LocalizationProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;